import React from 'react';
import { useI18n } from '../../context/I18nContext';

const MultipleGroupBox = ({
  title,
  count,
  isSheathGroup = false,
  hasIssues = false,
  isSelectionModeEnabled = false,
  allSelected = false,
  someSelected = false,
  onToggleSelection,
  onClick,
  compact = false,
  children
}) => {
  const { t } = useI18n();

  return (
    <div
      className={`border rounded-lg ${compact ? 'p-2' : 'p-3'} transition-colors cursor-pointer ${hasIssues
        ? 'bg-amber-50 border-amber-200 hover:bg-amber-100 border-l-4 border-l-amber-400'
        : isSheathGroup
          ? 'bg-sky-50 border-sky-200 hover:bg-sky-100 border-l-4 border-l-sky-400'
          : 'bg-green-50 border-green-200 hover:bg-green-100 border-l-4 border-l-green-400'
        }`}
      onClick={onClick}
    >
      <div className={`flex items-center justify-between ${compact ? 'mb-2' : 'mb-3'}`}>
        <div className="flex items-center gap-3">
          {isSelectionModeEnabled && (
            <label className="flex items-center cursor-pointer flex-shrink-0" onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                checked={allSelected}
                ref={(input) => {
                  if (input) input.indeterminate = !allSelected && someSelected;
                }}
                onChange={onToggleSelection}
                className="w-5 h-5 text-green-600 border-2 border-gray-300 rounded focus:ring-green-500 focus:ring-2"
              />
            </label>
          )}

          <span className="font-medium text-base">{title}</span>

          <span className="text-sm text-gray-500">
            {count} {isSheathGroup ? t('cableList.cables') : t('cableList.connectedCables')}
          </span>

          {hasIssues && (
            <span className="text-xs text-amber-600 bg-amber-100 px-2 py-1 rounded-full">
              {t('cableList.hasProblems')}
            </span>
          )}
        </div>

        <div className={`px-3 py-1 rounded-full text-sm font-medium ${isSheathGroup
          ? 'bg-sky-100 text-sky-800'
          : 'bg-green-100 text-green-800'
          }`}>
          {isSheathGroup ? t('cableList.sheath') : t('cableList.multiple')}
        </div>
      </div>

      <div className={compact ? 'space-y-2' : 'space-y-3'}>
        {children}
      </div>
    </div>
  );
};

export default MultipleGroupBox;
